import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Icon from "../Icon";
import HCChart from "./HCChart";
import ReactPaginate from 'react-paginate';
import { Col, Dropdown, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Embed from "./Embed";
import Image from "./Image";
import { FormattedMessage } from 'react-intl';


const Charts = ({ theme, publication, selectedChart, setSelectedChart, mode }) => {
    const history = useNavigate();
    const [chartList, setChartList] = useState([]);
    const [initStepIndex, setInitStepIndex] = useState(0);

    let { name, chart } = useParams();

    /* eslint-disable */
    useEffect(() => {
        if (!chart && publication.precontent) {
            setSelectedChart(false);
            return;
        };
        setChartList(publication?.chartlist || []);
        if ((!selectedChart || selectedChart.htmlname !== chart) && publication.chartlist) {
            const paramsLoaded = publication.chartlist.find(c => c.htmlname === chart);
            setInitStepIndex(publication.chartlist.findIndex(c => c.htmlname === chart) || 0);
            setSelectedChart(paramsLoaded || publication.chartlist[0]);
        }
    }, [publication, chart])

    const setHistory = (htmlname) => {
        history(`/kiadvany/${name}/${htmlname}`);
    }

    const handleSelectChart = (chart) => {
        setHistory(chart.htmlname);
        setSelectedChart(chart);
    }

    const handlePageClick = (event) => {
        const selectedChart = chartList[event.selected];
        if (selectedChart) {
            handleSelectChart(selectedChart)
        }
    };

    const stepperBtnIconColor = (type) => {
        const defaultColor = mode !== "dark" ? "white" : "white";
        return defaultColor;
    }

    const startChart = () => {
        handleSelectChart(publication.chartlist[0]);
    }
    /* eslint-disable */
    return (<>
        <Row>
            <Col sm={10} xs={12}>
                <h1 className="publication-title">
                    <Icon icon={publication.icon} className={mode === "dark" ? "darkgray" : "darkbg"} /> {publication.title}
                </h1>
            </Col>
            <Col sm={2} className={"charts-dropdown"}>
                <Dropdown>
                    <Dropdown.Toggle id="charts"

                        className={`button`}>
                        <Icon icon="chart"

                        /> <FormattedMessage id="table_of_contents" defaultMessage="Tartalom" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {publication && <div className={`bg-${theme && theme.url}`}>
                            <div className="dropdown-header" role="heading">
                                <h1><Icon icon={publication.icon} /> {publication.title}
                                    <Dropdown.Toggle className="right">
                                        <Icon icon="x-lg" />
                                    </Dropdown.Toggle>
                                </h1>

                            </div>
                            {publication.chartlist && publication.chartlist.map((chart, key) => <Dropdown.Item><Link to={`/kiadvany/${publication.htmlname}/${chart.htmlname}`} className="dropdown-item" role="button" tabindex="0" >{(key + 1)}. {chart.title.replace("*", "").replace(/<sup>.*?<\/sup>/g, "")}</Link></Dropdown.Item>)}
                        </div>}
                    </Dropdown.Menu>
                </Dropdown>
            </Col>
        </Row>
        <div className="content">
            {!chart && publication.precontent &&
                <Row>
                    <Col sm={10} className="pre-content" dangerouslySetInnerHTML={{ __html: publication.precontent }}></Col>
                    <Col>
                        <button className="button next btn btn-primary ms-auto"
                        onClick={startChart }>
                            Tovább az ábrákra
                                <Icon
                            icon="chevron-right"
                            className={stepperBtnIconColor("next")}
                        />
                    </button>
                   </Col>
            </Row>}
        {selectedChart && <div className="chart-container">
            {selectedChart.charts && <HCChart theme={theme} charts={selectedChart.charts} constructorType={selectedChart.type === "map" ? "mapChart" : "chart"} mode={mode} publication={publication} />}
            {selectedChart.file && <Embed selectedChart={selectedChart} mode={mode} key={mode} publicationType={publication.type} />}
            {selectedChart.image && <Image selectedChart={selectedChart} mode={mode} publicationType={publication.type} />}
            {chartList && selectedChart && <div className="stepper">
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                        <button className="button next">
                            <Icon
                                icon="chevron-right"
                                className={stepperBtnIconColor("next")}
                            />
                        </button >}
                    previousLinkClassName={"stepper-prev"}
                    disabledClassName={"disabled"}
                    nextLinkClassName={"stepper-next"}
                    forcePage={initStepIndex >= 0 ? initStepIndex : 0}
                    onPageChange={handlePageClick}
                    activeClassName={"active bg-" + publication.type}
                    pageRangeDisplayed={5}
                    pageCount={chartList.length}
                    //forcePage={(publication && publication.chartlist.findIndex(c => c.htmlname === selectedChart.htmlname)) || 0}
                    previousLabel={
                        <button className="button prev">
                            <Icon
                                icon="chevron-left"
                                className={stepperBtnIconColor("prev")}
                            />
                        </button>}
                    renderOnZeroPageCount={null}
                />
            </div>}
        </div>}
        {selectedChart && selectedChart.content && <div className="chart-content" dangerouslySetInnerHTML={{ __html: selectedChart.content }}></div>}
    </div>
    </>)
}

export default Charts;
